import moment from 'moment-timezone';

export const localTimestampInput = (instant: string, timezone: string) => moment(instant).tz(timezone).format('HH:mm');

const LOCAL_FORMAT = 'YYYY-MM-DDTHH:mm';

/** Edit only the clock time, retaining the event's calendar date in the hospital's zone. */
export const directTimestampInstant = (local: string, timezone: string, original: string): string | null => {
  if (!/^\d{2}:\d{2}$/.test(local)) return null;
  if (local === localTimestampInput(original, timezone)) return original;
  const dateAndTime = `${moment(original).tz(timezone).format('YYYY-MM-DD')}T${local}`;
  // Reject nonexistent DST times instead of silently shifting the operator's input.
  const matches = (value: moment.Moment) =>
    value.isValid() && value.clone().tz(timezone).format(LOCAL_FORMAT) === dateAndTime;
  // In the repeated fall-back hour keep the original's offset (a second 01:30 edited to 01:40 stays in that hour).
  const sameOffset = moment
    .utc(dateAndTime, LOCAL_FORMAT, true)
    .subtract(moment(original).tz(timezone).utcOffset(), 'minutes');
  if (matches(sameOffset)) return sameOffset.toISOString();
  const value = moment.tz(dateAndTime, LOCAL_FORMAT, true, timezone);
  return matches(value) ? value.toISOString() : null;
};
